import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { always } from 'ramda';
import { forceClockInBeforeSaleEnabled, getActiveBarberIds, isTimerActive } from '../selectors';
import { isBarberUser } from '../../../auth/selectors';
import confirmModal from '../../../common/confirmModal';
import { getByIds } from '../../barbers/selector';

/**
 * @param shouldIgnoreChecks Ignores clock-in rule enforcement when the function returns true
 */
const withCheckBarberIsClockedIn = (handlerName, getBarberIdsCallback, shouldIgnoreChecks = always(false)) => compose(
  connect((state, props) => {
    const activeBarberIds = getActiveBarberIds(state);
    const inactiveBarberIds = (getBarberIdsCallback(props) || [])
      .filter(barberId => !activeBarberIds.includes(barberId));

    return ({
      inactiveBarbers: getByIds(state, inactiveBarberIds),
      isBarberUserClockedIn: isTimerActive(state),
      isBarberUser: isBarberUser(state),
      forceClockInBeforeSaleEnabled: forceClockInBeforeSaleEnabled(state),
    });
  }),
  withHandlers({
    [handlerName]: props => async (...args) => {
      if (!props.forceClockInBeforeSaleEnabled || shouldIgnoreChecks(props)) {
        return props[handlerName](...args);
      }

      if (props.isBarberUser && !props.isBarberUserClockedIn) {
        return confirmModal({
          message: 'Please clock-in before proceeding',
          showConfirmButton: false,
          showNegativeButton: false,
        });
      }

      if (!props.isBarberUser && props.inactiveBarbers.length !== 0) {
        const barberNames = props.inactiveBarbers
          .map(({ firstName, lastName }) => `${firstName} ${lastName}`)
          .join(', ');
        const toBeForm = props.inactiveBarbers.length === 1 ? 'is' : 'are';

        const message = `${barberNames} ${toBeForm} not clocked-in. Please clock-in before proceeding with the transaction`;

        return confirmModal({
          message,
          showConfirmButton: false,
          showNegativeButton: false,
        });
      }

      return props[handlerName](...args);
    },
  }),
);

export default withCheckBarberIsClockedIn;
